export const statPropMap = {
	totalConversions: {
		bgColor: 'rgb(248,165,194, 0.2)',
		color: 'rgb(248,165,194)',
		label: 'Conversions',
	},
	totalInvitesClicked: {
		bgColor: 'rgb(243,166,131, 0.2)',
		color: 'rgb(243,166,131)',
		label: 'Invites Clicked',
	},
	totalInfluencers: {
		bgColor: 'rgb(162,210,143, 0.2)',
		color: 'rgb(162,210,143)',
		label: 'Created Influencers',
	},
	totalRevenue: {
		bgColor: 'rgb(99,205,218, 0.2)',
		color: 'rgb(99,205,218)',
		label: 'Revenue',
	},
	totalUtilizationRate: {
		bgColor: 'rgb(189,169,234, 0.2)',
		color: 'rgb(189,169,234)',
		label: 'Utilization Rate',
	},
	totalUtilizedInfluencers: {
		bgColor: 'rgb(245,205,121, 0.2)',
		color: 'rgb(245,205,121)',
		label: 'Utilized Influencers',
	},
};
